// Utilitários para formatação de dados do relatório PIS/COFINS

export const formatters = {
  cnpj: (value) => {
    if (!value) return "";
    const v = value.replace(/\D/g, "").padEnd(14, " ");
    return v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  },
  monetary: (value) => {
    if (value === null || value === undefined || value === "") return "R$ 0,00";
    const num = Number(value);
    if (Number.isNaN(num)) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(num);
  },
};

// Função para calcular valor baseado em Composição Projeto = true
export const calcularValorResumo = (resumo) => {
  try {
    const dados = resumo?.resumo?.dados || [];

    let total = 0;
    for (const row of dados) {
      // Verificar se Composição Projeto__boolean é verdadeiro
      const composicaoProjeto = row["Composição Projeto__boolean"];

      if (composicaoProjeto === true) {
        // Pegar o valor de Composição Calculo__monetary
        const composicaoCalculo = row["Composição Calculo__monetary"];

        const num = Number(composicaoCalculo);
        if (!Number.isNaN(num)) {
          total += num;
        }
      }
    }

    return total;
  } catch (error) {
    return 0;
  }
};

// Função para processar dados dos resumos
export const processarDadosResumos = (resumos) => {
  const steps = [];

  console.log("🔍 DEBUG processarDadosResumos - resumos recebidos:", resumos);

  if (resumos && resumos.length > 0) {
    // Usar apenas dados reais dos resumos - sem linhas em branco
    resumos.forEach((resumo, index) => {
      console.log(`🔍 DEBUG resumo ${index}:`, resumo);

      const valorCalculado = calcularValorResumo(resumo);

      // Tentar diferentes estruturas para encontrar a descrição
      const descricao =
        resumo?.resumo?.complemento?.descricao ||
        resumo?.complemento?.descricao ||
        resumo?.descricao ||
        resumo?.resumo?.descricao ||
        `Motor ${index + 1}`;

      // Tentar diferentes estruturas para encontrar a fundamentação
      const fundamentacao =
        resumo?.resumo?.complemento?.fundamentacao ||
        resumo?.complemento?.fundamentacao ||
        resumo?.fundamentacao ||
        resumo?.resumo?.fundamentacao ||
        "";

      // Tentar diferentes estruturas para encontrar a medida judicial
      const medidaJudicial =
        resumo?.resumo?.complemento?.medidaJudicial ||
        resumo?.complemento?.medidaJudicial ||
        resumo?.medidaJudicial ||
        resumo?.resumo?.medidaJudicial ||
        "DESNECESSIDADE";

      const tipo =
        medidaJudicial === "DESNECESSIDADE" ? "DESNECESSIDADE" : "SUGESTAO";

      console.log(`📊 DEBUG resumo ${index} processado:`, {
        descricao,
        fundamentacao,
        medidaJudicial,
        tipo,
        valorCalculado,
      });

      steps.push({
        step: descricao,
        teseJudicial: fundamentacao,
        valor: valorCalculado,
        composicaoProjeto: valorCalculado > 0,
        tipo: tipo,
      });
    });
  }

  console.log("📋 DEBUG steps finais:", steps);
  return steps;
};

// Função para calcular totais
export const calcularTotais = (mockData) => {
  const totalJudicial = mockData
    .filter((step) => step.tipo === "SUGESTAO")
    .reduce((acc, step) => acc + step.valor, 0);

  const totalSemJudicial = mockData
    .filter((step) => step.tipo === "DESNECESSIDADE")
    .reduce((acc, step) => acc + step.valor, 0);

  const totalGeral = totalJudicial + totalSemJudicial;

  return {
    totalJudicial,
    totalSemJudicial,
    totalGeral,
  };
};
